<ng-container *ngIf="profileCard">
	<div class="profile-item" fxLayout="row" fxLayoutAlign="start stretch">
		<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="20px" fxLayoutGap.xs="10px">
			<div class="profile-pic-block" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="0px"
				fxLayoutGap.xs="0px">
				<div fxFlex="0 0">
					<ng-container *ngIf="profileCard.skillMPermission === 'yes'">
						<div appDynoProgress diameter="58px" [progress]="profileCard?.progress || 0" radius="100%" [antiClock]="true"
						progressSize="4px">
							<div fxLayoutAlign="center center" (click)="info()" class="profile-pic cursor-pointer">
								<img [src]="profileCard?.profileThumbnail" (error)="gfService.setErrorImage($event, 'man')" alt=""
									class="img">
							</div>
						</div>
					</ng-container>
					
					<ng-container *ngIf="profileCard.skillMPermission === 'no'">
						<div appDynoProgress diameter="58px" [progress]="profileCard?.progress || 0" radius="100%" [antiClock]="true"
						progressSize="0px">
							<div fxLayoutAlign="center center" (click)="info()" class="profile-pic cursor-pointer">
								<img [src]="profileCard?.profileThumbnail" (error)="gfService.setErrorImage($event, 'man')" alt=""
									class="img">
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="profile-detail-block" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
				fxLayoutAlign="space-between stretch" fxLayoutGap="10px" fxLayoutGap.xs="10px">
				<div class="profile-content" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
					<div fxLayout="row" fxLayoutAlign="space-between center">
						<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
							<h1 (click)="info()" class="username linkable">{{profileCard?.title}}</h1>
							<ng-container *ngIf="profileCard?.isAdmin">
								<span class="sub-txt-patch is-admin">{{locale.translate('admin')}}</span>
							</ng-container>
						</div>
						<ng-container *ngIf="profileCard?.status">
							<span class="sub-txt-patch" [ngClass]="profileCard?.statusCode">{{profileCard?.status}}</span>
						</ng-container>
					</div>
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="5px">
						<div class="experience-dtl" fxLayout="row wrap" fxLayoutGap="4px" fxLayoutGap.xs="4px">
							<ng-container *ngFor="let info of profileCard?.shortInfo; let index = index">
								<span class="short-info-caption">{{info?.value}}</span>
								<ng-container *ngIf="index !== (profileCard?.shortInfo?.length - 1)">
									<span>|</span>
								</ng-container>
							</ng-container>

						</div>
						<div fxLayout="row" fxLayoutGap="2px" fxLayoutGap.xs="2px">
							<div class="profile-description" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
								<ng-container *ngFor="let info of profileCard?.contactInfo; let index = index">
									<div fxLayout="row" fxLayoutGap="5px">
										<p>{{info?.value}}</p>
										<ng-container *ngIf="index !== (profileCard?.contactInfo?.length - 1)">
											<span>|</span>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
				<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex.xs="auto">
					<mat-divider></mat-divider>
					<div class="profile-skills" fxLayout="row wrap" fxLayoutAlign="space-between stretch">
						<div fxLayout="row wrap" fxLayoutAlign="start stretch" fxLayoutGap="5px">
							<ng-container *ngIf="profileCard?.designation">
								<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="skill-block">
									<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
										<mat-icon svgIcon="role"></mat-icon>
										<span class="sub-caption-1"> {{ profileCard?.designation }}</span>
									</div>
								</div>
							</ng-container>
							<ng-container
								*ngIf="profileCard?.workGroupOwnerName || !([null, undefined].includes(profileCard?.workGroupOwnerCount)) || !([null, undefined].includes(profileCard?.membersCount))">
								<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="skill-block">
									<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
										<mat-icon svgIcon="workgroup"></mat-icon>
										<ng-container *ngIf="profileCard?.workGroupOwnerName">
											<span class="sub-caption-1">{{profileCard?.workGroupOwnerName}}
												<ng-container *ngIf="!([null, undefined].includes(profileCard?.workGroupOwnerCount))">
													+ {{profileCard?.workGroupOwnerCount}}
												</ng-container>
											</span>
										</ng-container>
									</div>
									<ng-container *ngIf="!([null, undefined].includes(profileCard?.membersCount))">
										<app-badge [count]="profileCard?.membersCount" icon="person" size="16px" class="overview">
										</app-badge>
									</ng-container>
								</div>
							</ng-container>
						</div>
						<!-- <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px"
							class="skill-block">
							<button class="icon-btn" mat-icon-button>
								<mat-icon svgIcon="like"></mat-icon>
							</button>
							<button class="icon-btn" mat-icon-button>
								<mat-icon svgIcon="certificate"></mat-icon>
							</button>
							<button class="icon-btn" mat-icon-button>
								<mat-icon svgIcon="contribution"></mat-icon>
							</button>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
